/* eslint-disable */
import React, { useState, useEffect,useContext } from 'react';
import {
  Grid,
  RACCheckBox,
  Typography,
  RACModalCard,
  Box,
  RACButton,
  RACRadio,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACDateTimeLabel
} from '@rentacenter/racstrap';
import Barcode from 'react-barcode';
import { barcodeStyles } from '../../stylesJS/barcodeStyles';
import { AgreementDetails } from '../interface/paymentInfoInterface';
import { calculateBarcodeAmount } from '../../utils/utils';
import { ReactComponent as PayCash } from './../../assets/images/paycash.svg';
import { ReactComponent as Oxxo } from './../../assets/images/Oxxo_Logo 1.svg';
import { ReactComponent as RacLogo } from '../../assets/images/rac_logo.svg.svg';
import { ReactComponent as AlertIcon } from './../../assets/apiErrorIcon.svg';
import { useTranslation } from "react-i18next";
import CONSTANTS from '../constants/constant';
import { agreementContext } from '../context/PaymentInformationContext';
import { HT_ID_MAP } from '../constants/htIdMap';

interface BarcodePropsInterface {
  barcodeAgreements: AgreementDetails[];
  showBarcodeOptions?: boolean;
  setShowBarcodeOptions?: React.Dispatch<React.SetStateAction<boolean>>;
  viewClick?: boolean;
}

interface BarcodeAgreementWithChecks extends AgreementDetails {
  oxxo: boolean;
  payCash: boolean;
}

type BarcodeType = 'oxxo' | 'payCash';

const calculateCheckDigit = (data: string) => {
  let total = 0;
  for (let i = 0; i < data.length; i++) {
    const digit = parseInt(data[data.length - 1 - i], 10);
    const multiplier = i % 2 === 0 ? 2 : 1;
    const product = digit * multiplier;
    total += product > 9 ? Math.floor(product / 10) + (product % 10) : product;
  }
  const residue = total % 10;
  return residue === 0 ? 0 : 10 - residue;
};

export const BarcodeGeneration = ({
  barcodeAgreements,
  showBarcodeOptions,
  setShowBarcodeOptions,
  viewClick,
}: BarcodePropsInterface) => {
  const classes = barcodeStyles();
   const { featureFlags,originCountry } = useContext(agreementContext);
   
  useEffect(()=>{
    debugger;
    console.log('barcode generation styles ', classes);
  },[])

  const [clonedAgreements, setClonedAgreements] = useState<
    BarcodeAgreementWithChecks[]
  >([]);
  const [showMainModal, setShowMainModal] = useState<boolean>(true);
  const [showBarcodeModal, setShowBarcodeModal] = useState<boolean>(false);
  const { t } = useTranslation("PayCash");
  const [selectedForBarcode, setSelectedForBarcode] = useState<
    { agreement: AgreementDetails; type: BarcodeType }[]
  >([]);
  const [printOption, setPrintOption] = useState<'oxxo' | 'payCash' | 'both'>(
    'both'
  );
  const [selectAllOxxo, setSelectAllOxxo] = useState<boolean>(false);
  const [selectAllPayCash, setSelectAllPayCash] = useState<boolean>(false);
  //to show the error modal if there is an error in generating the bar code
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

  const base64String = window.sessionStorage.getItem('storeDetails') || '';
  const decodedString = atob(base64String);
  const jsonData = JSON.parse(decodedString);
  const workPhoneNumber = jsonData.workPhoneNumber || '';

  useEffect(() => {
    // Initialize cloned agreements with checkboxes
    const cloned = barcodeAgreements.map((agmt) => ({
      ...agmt,
      oxxo: agmt.oxxo ?? false,
      payCash: agmt.payCash ?? false,
    }));
    setClonedAgreements(cloned);

    if (viewClick && cloned.length > 0) {
      setShowMainModal(false);
      setShowBarcodeModal(true);

      // Only select agreements for the barcode type(s) that are true
      const selected: { agreement: AgreementDetails; type: BarcodeType }[] = [];
      cloned.forEach((agmt) => {
        if (agmt.oxxo) {
          selected.push({ agreement: agmt, type: 'oxxo' });
        }
        if (agmt.payCash) {
          selected.push({ agreement: agmt, type: 'payCash' });
        }
      });
      setSelectedForBarcode(selected);
    } else {
      setShowMainModal(true);
      setShowBarcodeModal(false);
      setSelectedForBarcode([]);
    }

    setSelectAllOxxo(false);
    setSelectAllPayCash(false);
    setPrintOption('both');
  }, [barcodeAgreements, viewClick]);

  const isAnyAgreementSelected = () => {
    return clonedAgreements.some((agmt) => agmt.oxxo || agmt.payCash);
  };
  function formatPhoneNumber(phoneNumber) {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6
    )}`;
  }
  //build barcode data
  const buildBarcodeData = (agreement: AgreementDetails, type: BarcodeType) => {
    const paddedAgreement = agreement.agreementNumber.padStart(10, '0');
    
    // For 8-length agreements, extract first 3 chars as store code and look up the store number
    let agreementDigits3To12: string;
    
    if (agreement.agreementNumber.length != 8) {
      agreementDigits3To12 = paddedAgreement.substring(0, 10);
    } else {
      // Extract first 3 chars of original agreement number as store code (e.g., 'kev' -> '08501')
      const storeCodeFromAgreement = agreement.agreementNumber.substring(0, 3).toLowerCase();
      
      // Look up store number from map (e.g., 'kev' -> '08501')
      const mappedStoreNumber = HT_ID_MAP[storeCodeFromAgreement as keyof typeof HT_ID_MAP] || agreement.storeNumber.padStart(5, '0');
      
      // agreementDigits3To12: mapped store number + last 5 of agreement
      agreementDigits3To12 = mappedStoreNumber + agreement.agreementNumber.substring(3);
    }

    if (type === 'oxxo') {
      const companyId = CONSTANTS.COMPANY_CODE;
      const currentStoreNumber = agreement.storeNumber.padStart(5, '0');
      const expirationDate = (agreement.expirationDate || '')
        .replace(/-/g, '')
        .slice(0, 8);
      const paymentAmount = String(calculateBarcodeAmount(agreement, true))
        .replace('.', '')
        .padStart(6, '0');
      const barcodeData = `${companyId}${agreementDigits3To12}${currentStoreNumber}${expirationDate}${paymentAmount}`;
      const checkDigit = calculateCheckDigit(barcodeData);
      if (
        Number(agreementDigits3To12) &&
        Number(companyId) &&
        Number(currentStoreNumber) &&
        Number(expirationDate) &&
        Number(paymentAmount) &&
        Number(checkDigit) >= CONSTANTS.NUMBER_ZERO
      )
        return `${barcodeData}${checkDigit}`;
    } else {
      const expirationDate = (agreement.expirationDate || '')
        .replace(/-/g, '')
        .slice(0, 8);
      const formattedAmount = String(calculateBarcodeAmount(agreement, false, true))
        .replace('.', '')
        .padStart(6, '0');
      const currentStore = agreement.storeNumber.padStart(5, '0');
      if (
        Number(agreementDigits3To12) &&
        Number(expirationDate) &&
        Number(formattedAmount) &&
        Number(currentStore)
      )
        return `${agreementDigits3To12}${expirationDate}${formattedAmount}${currentStore}`;
    }
    setShowErrorModal(true);
    return '';
  };

  // Handle Generate
  const handleGenerate = () => {
    const selected: { agreement: AgreementDetails; type: BarcodeType }[] =
      showBarcodeOptions
        ? getSelectedForPrintOptions()
        : getSelectedForCheckedAgreements();

    setSelectedForBarcode(selected);
    if (selected.length > 0) {
      setShowMainModal(false);
      setShowBarcodeModal(true);
    }
  };
   const printDiv = () => { 
  const el = document.getElementById('barcodeData');
  if (!el) {
    return;
  }
  // Wrap each direct child of barcodeData in a page-break div
  // This assumes that each barcode item is a direct child (likely a <Box> in your code)
  // If not, adjust selector accordingly to select each barcode block
  const containers = Array.from(el.children);
  const wrappedContent = containers.map(child => `<div class="page-break">${child.outerHTML}</div>`).join('');

  const printWindow = window.open('', '', 'height=600,width=800');
  const racLogoSrc = require('../../assets/images/rac_logo.svg.svg').default;
  if (!printWindow) {
    return;
  }
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Receipt</title>
        <style>
          body { font-family: Arial, sans-serif; }
          .keyvalue { display: flex; align-items: center; margin-bottom: 8px; }
          .key { font-weight: bold; min-width: 100px; margin-right:8px; }
          .logo { margin-right:8px; height:35px; }
          .page-break { page-break-after: always; }
        </style>
      </head>
      <body>
        <div style='text-align:left;padding:10px 0;'>
          <img src=${racLogoSrc} class='logo' alt='' />
          <h3 style='display:inline-block;margin:0 0 0 8px;'>Print Receipt</h3>
        </div>
        ${wrappedContent}
      </body>
    </html>
  `);
  printWindow.document.close();
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};
  const getSelectedForPrintOptions = () => {
    const selected: { agreement: AgreementDetails; type: BarcodeType }[] = [];
    barcodeAgreements.forEach((agmt) => {
      if( !(agmt.isLDWActionPerformed === 'Y' ||
          agmt.isLDWActionPerformed === 'N' ||
          agmt.isEditScheduleEdited ||
          agmt.agreementStatus === 'PRELIM' ||
          agmt.agreementStatus === 'PRELIMINV' ||
          agmt.agreementStatus === 'PEND')){
            console.log('agmt ', agmt);
      if (printOption === 'oxxo') {
        selected.push({ agreement: agmt, type: 'oxxo' });
      } else if (printOption === 'payCash') {
        selected.push({ agreement: agmt, type: 'payCash' });
      } else if (printOption === 'both') {
        selected.push({ agreement: agmt, type: 'oxxo' });
        selected.push({ agreement: agmt, type: 'payCash' });
      }
    }
    });
    return selected;
  };
  const getSelectedForCheckedAgreements = () => {
    const selected: { agreement: AgreementDetails; type: BarcodeType }[] = [];
    clonedAgreements.forEach((agmt) => {
      if (printOption === 'oxxo' && agmt.oxxo) {
        selected.push({ agreement: agmt, type: 'oxxo' });
      } else if (printOption === 'payCash' && agmt.payCash) {
        selected.push({ agreement: agmt, type: 'payCash' });
      } else if (printOption === 'both') {
        if (agmt.oxxo) selected.push({ agreement: agmt, type: 'oxxo' });
        if (agmt.payCash) selected.push({ agreement: agmt, type: 'payCash' });
      }
    });
    return selected;
  };

  // Handle closing barcode modal
  const handleCloseBarcodeModal = () => {
    setShowBarcodeModal(false);
    setShowMainModal(true);
    setSelectedForBarcode([]);
    if (setShowBarcodeOptions) setShowBarcodeOptions(false);
  };

  // Handle checkbox change
  const handleCheckboxChange = (agreementNumber: string, key: BarcodeType) => {
    setClonedAgreements((prev) =>
      prev.map((agmt) =>
        agmt.agreementNumber === agreementNumber
          ? { ...agmt, [key]: !agmt[key] }
          : agmt
      )
    );
  };

  // Handle select all Oxxo
  const handleSelectAllOxxoChange = () => {
    setSelectAllOxxo((prev) => {
      const newValue = !prev;
      setClonedAgreements((prevAgmts) =>
        prevAgmts.map((agmt) => ({ ...agmt, oxxo: newValue }))
      );
      return newValue;
    });
  };

  // Handle select all PayCash
  const handleSelectAllPayCashChange = () => {
    setSelectAllPayCash((prev) => {
      const newValue = !prev;
      setClonedAgreements((prevAgmts) =>
        prevAgmts.map((agmt) => ({ ...agmt, payCash: newValue }))
      );
      return newValue;
    });
  };

  // Table Head
  const agreementTableHead = () => (
    <>
      <RACTableCell className={classes.agreementCell}>{t("Agreement #")}</RACTableCell>
      <RACTableCell className={classes.tableCell}>
        <RACCheckBox
          role="checkbox"
          id="select-all-oxxo"
          checked={selectAllOxxo}
          onChange={handleSelectAllOxxoChange}
        />
        <label htmlFor="select-all-oxxo">{t("Oxxo Pay")}</label>
      </RACTableCell>
      <RACTableCell className={classes.tableCell}>
        <RACCheckBox
          role="checkbox"
          id="select-all-paycash"
          checked={selectAllPayCash}
          onChange={handleSelectAllPayCashChange}
        />
        <label htmlFor="select-all-paycash">{t("Pay Cash")}</label>
      </RACTableCell>
    </>
  );

  // Table Body
  const agreementTableBody = () => (
    <>
      {clonedAgreements.map((el) => (
        <RACTableRow key={el.agreementNumber} backgroundColor="#fff">
          <RACTableCell className={classes.agreementCell}>
            <Typography className={classes.ml30px}>
              {el.agreementNumber}
            </Typography>
          </RACTableCell>
          <RACTableCell className={classes.tableCell}>
            <Grid style={{ display: 'flex', marginLeft: '100px' }}>
              <Grid>
                <RACCheckBox
                  role="checkbox"
                  id={`oxxo-${el.agreementNumber}`}
                  checked={el.oxxo}
                  onChange={() =>
                    handleCheckboxChange(el.agreementNumber, 'oxxo')
                  }
                  data-testid="oxxopay"
                />
              </Grid>
              <Grid>
                <Typography style={{ visibility: 'hidden' }}>
                  {t("Oxxo Pay")}
                </Typography>
              </Grid>
            </Grid>
          </RACTableCell>
          <RACTableCell className={classes.tableCell}>
            <Grid style={{ display: 'flex', marginLeft: '105px' }}>
              <Grid>
                <RACCheckBox
                  role="checkbox"
                  id={`paycash-${el.agreementNumber}`}
                  checked={el.payCash}
                  onChange={() =>
                    handleCheckboxChange(el.agreementNumber, 'payCash')
                  }
                  data-testid="paycashpay"
                />
              </Grid>
              <Grid>
                <Typography style={{ visibility: 'hidden' }}>
                  {t("Pay Cash")}
                </Typography>
              </Grid>
            </Grid>
          </RACTableCell>
        </RACTableRow>
      ))}
    </>
  );

  function ListAgreements() {
    return (
      <>
        <Grid item md={12} className={classes.textCenter}>
          <RACTable
            className={`${classes.racGrid} ${classes.mb32}`}
            renderTableHead={agreementTableHead}
            renderTableContent={agreementTableBody}
          />
        </Grid>
        <Grid container justifyContent="flex-end" style={{ marginTop: 24 }}>
          <RACButton
            variant="contained"
            color="primary"
            onClick={handleGenerate}
            disabled={!isAnyAgreementSelected()}
            style={{paddingRight:'10px',paddingBottom:'10px'}}
          >
            {t("Generate")}
          </RACButton>
        </Grid>
      </>
    );
  }

  function BarcodeModalContent() {
    return (
      <>
        <Box className={`${classes.barcodeModal}`}>
          <Grid
            style={{
              margin: '0px 0px',
              backgroundColor: '#2179FE',
              height: '30px',
              borderRadius: '15px 15px 0px 0px',
              padding: '0px',
            }}
          >
            <span>{''}</span>
          </Grid>
          <Grid className={`${classes.ml15px}`}>
            <RacLogo style={{ width: '75px', marginBottom: '-75px' }} />
            <Typography variant="h6" className={`${classes.BarcodeTitle}`}>
              {' '}
              {t("BARCODE RECEIPT")}
            </Typography>
            <Grid className={`${classes.p15px}`} id = 'barcodeData'>
              {selectedForBarcode.map(({ agreement, type }) => {
                const barcodeValue = buildBarcodeData(agreement, type);
                return (
                  <Box key={`${agreement.agreementNumber}-${type}`} mb={4}>
                    <Box mt={2}>
                      <Grid
                        className={`${classes.mb20px} ${classes.displayflex}`}
                      >
                        <Typography className={`${classes.listTitle}`}>
                          {t("Agreement #:")}
                        </Typography>
                        <Typography
                          className={`${classes.ml15pxngray}`}
                          style={{ fontSize: '17px' }}
                        >
                          {agreement.agreementNumber}{' '}
                          {type === 'oxxo' ? (
                            <Oxxo
                              style={{ marginLeft: '10px', height: '20px' }}
                            />
                          ) : (
                            <PayCash
                              style={{ marginLeft: '10px', height: '20px' }}
                            />
                          )}
                        </Typography>
                      </Grid>
                      <hr></hr>

                      <Grid
                        className={`${classes.displayflexgrid}`}
                        container
                        md={12}
                        lg={12}
                        sm={12}
                      >
                        <Grid
                          /*className={`${classes.respwidth265px}`} */ item
                          md={6}
                          lg={6}
                          sm={6}
                        >
                          <Grid
                            className={`${classes.mb20px} ${classes.displayflex}`}
                            style={{ minHeight: '45px' }}
                          >
                            <Typography className={`${classes.listTitle}`}>
                              {t("Store")}:
                            </Typography>
                            <Typography
                              className={`${classes.ml15pxngray}`}
                              style={{ fontSize: '17px' }}
                            >
                              {agreement.storeNumber}{' '}
                            </Typography>
                          </Grid>

                          <Grid
                            className={`${classes.mb20px} ${classes.displayflex}`}
                            style={{ minHeight: '45px' }}
                          >
                            <Typography className={`${classes.listTitle}`}>
                              {t("Article")}:
                            </Typography>
                            <Typography
                              className={`${classes.ml15pxngray}`}
                              style={{ fontSize: '17px' }}
                            >
                              {agreement.agreementDesc}
                            </Typography>
                          </Grid>

                          <Grid
                            className={`${classes.mb20px} ${classes.displayflex}`}
                            style={{ minHeight: '45px' }}
                          >
                            <Typography className={`${classes.listTitle}`}>
                              {t("Code")}:
                            </Typography>
                            <Typography className={`${classes.ml15pxngray}`}>
                              {type === 'oxxo' ? (
                                <Grid style={{ display: 'flex' }}>
                                  {' '}
                                  <Grid>
                                    <Oxxo />
                                  </Grid>
                                  <Typography
                                    style={{
                                      marginLeft: '5px',
                                      fontSize: '17px',
                                    }}
                                  >
                                    {' '}
                                    {t("Oxxo")}
                                  </Typography>
                                </Grid>
                              ) : null}
                              {type === 'payCash' ? (
                                <Grid style={{ display: 'flex' }}>
                                  {' '}
                                  <Grid>
                                    <PayCash />
                                  </Grid>
                                  <Typography
                                    style={{
                                      marginLeft: '5px',
                                      fontSize: '17px',
                                    }}
                                  >
                                    {' '}
                                    {t("Multi-comercios(7 Eleven, Kiosko, Circle K, Extra)")}
                                  </Typography>
                                </Grid>
                              ) : null}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          className={`${classes.mb20px}${classes.mr100px}`}
                          item
                          md={6}
                          lg={6}
                          sm={6}
                        >
                          <Grid
                            className={`${classes.mb20px} ${classes.displayflex}`}
                            style={{ minHeight: '45px' }}
                          >
                            <Typography className={`${classes.listTitle}`}>
                              {t("Contact")}:
                            </Typography>
                            <Typography
                              className={`${classes.ml15pxngray}`}
                              style={{ fontSize: '17px' }}
                            >
                              {formatPhoneNumber(workPhoneNumber)}
                            </Typography>
                          </Grid>

                          <Grid
                            className={`${classes.mb20px} ${classes.displayflex}`}
                            style={{ minHeight: '45px' }}
                          >
                            <Typography className={`${classes.listTitle}`}>
                              {t("Amount")}:
                            </Typography>
                            <Typography
                              className={`${classes.ml15pxngray}`}
                              style={{ fontSize: '17px' }}
                            >
                              ${ type== 'oxxo'? String(calculateBarcodeAmount(agreement,true)) : String(calculateBarcodeAmount(agreement,false,true)) }
                            </Typography>
                          </Grid>
                          <Grid
                            className={`${classes.mb20px} ${classes.displayflex}`}
                            style={{ minHeight: '45px' }}
                          >
                            <Typography className={`${classes.listTitle}`}>
                              {t("Expires")}:
                            </Typography>
                            {Number(featureFlags.DateTimeLocalization) === 1 ?
                             <RACDateTimeLabel value={agreement.expirationDate || ''} displayType ={'ShortDate'} country= {originCountry}  separator = {"-"} className={`${classes.barcodeDateCss}`}/>
                              :
                            <Typography
                              className={`${classes.ml15pxngray}`}
                              style={{ fontSize: '17px' }}
                            >{agreement.expirationDate}
                            </Typography>}
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* <Grid className={`${classes.mb20px} ${classes.displayflex}`}>
                                            <Typography className={`${classes.listTitle}`}>
                                                Store:</Typography>
                                            <Typography className={`${classes.ml15pxngray}`}>{agreement.storeNumber} {' '}
                                            </Typography>
                                            <Typography className={`${classes.listTitle}`}>
                                                Contact:</Typography>
                                            <Typography className={`${classes.ml15pxngray}`}>{agreement.storeNumber} {' '}
                                            </Typography>
                                        </Grid>
                                        <Grid container>
                                            <Grid item md= {12} className={`${classes.mb20px} ${classes.displayflex}`}>
                                            <Typography className={`${classes.listTitle}`}>
                                                Article:</Typography>
                                            <Typography className={`${classes.ml15pxngray}`}>
                                            </Typography>
                                            <Typography className={`${classes.listTitle}`}>
                                                Amount:</Typography>
                                            <Typography className={`${classes.ml15pxngray}`}>
                                            </Typography>
                                        </Grid>
                                        </Grid>
                                        
                                        <Grid className={`${classes.mb20px} ${classes.displayflex}`}>
                                            <Typography className={`${classes.listTitle}`}>
                                                Code:</Typography>
                                            <Typography className={`${classes.ml15pxngray}`}>
                                            </Typography>
                                            <Typography className={`${classes.listTitle}`}>
                                                Expires:</Typography>
                                            <Typography className={`${classes.ml15pxngray}`}>
                                            </Typography>
                                        </Grid> */}
                    </Box>
                    <Grid className={`${classes.barcodeGrid}`}>
                      <Grid className={`${classes.respMl55px}`}>
                        <Barcode
                          value={barcodeValue}
                          format="CODE128"
                          width={2}
                          height={100}
                          displayValue={true}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
            </Grid>
          </Grid>
        </Box>
        <Grid container justifyContent="flex-end">
          <RACButton
            className={`${classes.mx1} ${classes.noPrint}`}
            variant="outlined"
            color="primary"
            onClick={handleCloseBarcodeModal}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            className={`${classes.mx1} ${classes.noPrint}`}
            variant="contained"
            color="primary"
            onClick={() => {
              printDiv(); 
            }}
          >
            {t("Print")}
          </RACButton>
        </Grid>
      </>
    );
  }

  return (
    <>
      {showBarcodeOptions && !viewClick ? (
        <RACModalCard
          title={t("Print")}
          isOpen={true}
          maxWidth="md"
          borderRadius="4%"
          onClose={() => {
            setShowBarcodeOptions?.(false);
          }}
          closeIcon={true}
          className={classes.maxWidth500px}
          classes={{
            dialogTitle: `${classes.fz20px}`,
          }}
        >
          <Grid container direction="column" spacing={2}>
            <Grid md className={`${classes.radioOptionBgColor}`}>
              <RACRadio
                checked={printOption === 'oxxo'}
                onChange={() => setPrintOption('oxxo')}
                id="radio-oxxo"
                value={'oxxo'}
                className={`${classes.pl25px}`}
              />
              <label className={`${classes.ml15px}`}>
                {' '}
                <Oxxo />
              </label>
              <label
                htmlFor="radio-oxxo"
                className={`${classes.radioOption} ${classes.ml15px}`}
              >
                {t("Oxxo Pay")}
              </label>
            </Grid>
            <Grid md className={`${classes.radioOptionBgColor}`}>
              <RACRadio
                checked={printOption === 'payCash'}
                onChange={() => setPrintOption('payCash')}
                id="radio-paycash"
                value={'payCash'}
                className={`${classes.pl25px}`}
              />
              <label className={`${classes.ml15px}`}>
                {' '}
                <PayCash />
              </label>
              <label
                htmlFor="radio-paycash"
                className={`${classes.radioOption} ${classes.ml15px}`}
              >
                {t("Pay Cash")}
              </label>
            </Grid>
            <Grid md className={`${classes.radioOptionBgColor}`}>
              <RACRadio
                checked={printOption === 'both'}
                onChange={() => setPrintOption('both')}
                id="radio-both"
                value={'payCash'}
                className={`${classes.pl25px}`}
              />
              <label
                htmlFor="radio-both"
                className={`${classes.radioOption} ${classes.ml15px}`}
              >
                {t("Both Oxxo Pay and Pay Cash")}
              </label>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" style={{ marginTop: 24 }}>
            <RACButton
              variant="contained"
              color="primary"
              onClick={handleGenerate}
            >
              {t("Continue")}
            </RACButton>
          </Grid>
        </RACModalCard>
      ) : (
        showMainModal && !showBarcodeOptions && !viewClick && <ListAgreements />
      )}
      {showBarcodeModal && !showErrorModal && (
        <Grid className={`${classes.margin20px}`}>
          <RACModalCard
            title={t("Print Barcode")}
            isOpen={true}
            maxWidth="md"
            borderRadius="4%"
            onClose={() => {
              handleCloseBarcodeModal();
            }}
            closeIcon={true}
            className={`${classes.maxWidth700px}`}
            classes={{
              dialogTitle: `${classes.fz20px}`,
            }}
          >
            <BarcodeModalContent />
          </RACModalCard>
        </Grid>
      )}
      {showErrorModal && (
        <Grid className={`${classes.margin20px}`}>
          <RACModalCard
            title=""
            isOpen={true}
            maxWidth="xs"
            onClose={() => {
              setShowErrorModal(false);
              setShowBarcodeModal(false);
            }}
            closeIcon={true}
            borderRadius={'25px'}
            className={`${classes.mxwidth320px}`}
          >
            <Grid>
              <AlertIcon style={{ marginLeft: '135px' }} />
            </Grid>
            <>
              <Typography
                style={{ fontFamily: 'OpenSans-bold', textAlign: 'center' }}
              >
                {t("The Barcode is not generated")}
              </Typography>
            </>
            <>
              <Typography
                style={{ fontFamily: 'OpenSans-bold', textAlign: 'center' }}
              >
                {t("Please try again")}{' '}
              </Typography>
            </>
            <Grid container justifyContent="center" style={{ marginTop: 24 }}>
              <RACButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setShowErrorModal(false);
                  setShowBarcodeModal(false);
                }}
              >
                {t("Ok")}
              </RACButton>
            </Grid>
          </RACModalCard>
        </Grid>
      )}
    </>
  );
};